{
	"title": "Polityka prywatności",
	"backTitle": "Wstecz"
}
